if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.initSampleButton();
        this.initSquareFootageButtons();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }
          
      initSampleButton() {
        const orderSampleButton = document.getElementById('order-sample-button');
        const productTitle = document.getElementById('product__variant__title').textContent;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const quickAddModal = this.closest('quick-add-modal');

        //console.log('Quick Add Modal:', quickAddModal);
      
        if (document.querySelector('cart-drawer')) {
          orderSampleButton.setAttribute('aria-haspopup', 'dialog');
        }

        orderSampleButton.onclick = () => {
          const sampleProductId = "42788859248733"; // Sample product ID

          var sampleProductDescription = productTitle;
          window.sampleProductDescription = sampleProductDescription

          if (typeof sampleProductDescription === 'undefined' || sampleProductDescription === null)
          {
            sampleProductDescription = "test" 
          }

          //console.log('Sample Product Description:', sampleProductDescription);

          const payload = {
            items: [
              {
                id: sampleProductId,
                quantity: 1,
                properties: { "Sample Product": sampleProductDescription },
              },
            ],
          };

          //console.log("Payload for sample:", payload);

          fetch('/cart.js')
            .then((response) => response.json())
            .then((cartData) => {
              const sampleItems = cartData.items.filter((item) =>
                item.properties && item.properties["Sample Product"]
              );

              const existingSampleCount = sampleItems.reduce((count, item) => {
                if (item.properties["Sample Product"] === sampleProductDescription) {
                  return count + item.quantity;
                }
                return count;
              }, 0);

              if (existingSampleCount >= 2) {
                alert("You can only have a maximum of 2 samples of each item in your cart.");
                return;
              }

              const uniqueSampleCount = sampleItems.length;
              if (uniqueSampleCount >= 15) {
                document.getElementById("customAlert").style.display = "flex";
                return;
              }

              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
              })
                .then((response) => response.json())
                .then((data) => {
                  if (quickAddModal) {
                    // console.log('Success:', data);
                    quickAddModal.hide(true);
                    if (cart) cart.open();
                    else alert('Sample added successfully!');
                  } else {
                    // console.log('Success:', data);
                    if (cart) cart.open();
                    else alert('Sample added successfully!');
                  } 
                })
                .catch(() => alert('Error adding sample to cart.'));
            })
            .catch((error) => {
              console.error('Error fetching cart data:', error);
              alert('There was a problem checking your cart. Please try again.');
            });
        };
      }

      updateQuantityNeeded() {
        const sfPerCarton = parseFloat(document.getElementById('variantData').getAttribute('data-sf-per-carton'));
        const squareFeet = parseFloat(document.getElementById('sf_input').value);
        if (!isNaN(sfPerCarton) && sfPerCarton > 0) {
          const cartonsNeeded = Math.ceil(squareFeet / sfPerCarton); 
          const quantityInput = document.querySelector('.quantity__input');
          quantityInput.value = cartonsNeeded; // Update the value
        }
      } 

      updateSubtotalOverageTotalFields() {
        this.subtotalValue = document.querySelector('.subtotal-value');
        this.overageValue = document.querySelector('.overage-value');
        this.totalValue = document.querySelector('.total-sq-ft');
        this.boxesRequired = document.querySelector('.boxes-value');
        this.totalPrice= document.getElementById('total-price');
      
        const squarefootvalue = parseFloat(document.getElementById('sf_input').value) || 0;
        const overageSelection = parseFloat(document.getElementById('overageSelect').value) || 0;
        const sfPerCarton = parseFloat(document.getElementById('variantData').getAttribute('data-sf-per-carton')) || 1;
        const pricePerCarton = parseFloat(document.getElementById('variantData').getAttribute('data-price-per-carton')) || 1;
        //console.log('Price Per Carton: ', pricePerCarton);
        const quantityInput = document.querySelector('.quantity__input');
      
        const subtotal = squarefootvalue;
        const overage = squarefootvalue * overageSelection;
        const total = subtotal + overage;
      
        this.subtotalValue.textContent = `${subtotal.toFixed(0)} sq. ft.`;
        this.overageValue.textContent = `${overage.toFixed(0)} sq. ft.`;
        this.totalValue.textContent = `${total.toFixed(0)} sq. ft.`;
      
        const boxes = Math.ceil(total / sfPerCarton);
        if (this.boxesRequired) {
          this.boxesRequired.textContent = `${boxes} boxes`;
        }

        const totalprice = boxes * pricePerCarton;
        //console.log('Total Price: ', totalprice);
        if (this.totalPrice) {
          this.totalPrice.textContent = `Total Price: $${totalprice.toFixed(2)}`;
        }

        quantityInput.value = boxes; // Update the value
      }      

      initSquareFootageButtons() { 
          const sfInput = document.getElementById('sf_input');
          const overageSelect = document.getElementById('overageSelect');
          sfInput.dispatchEvent(new Event('input')); // Trigger input event to set initial cartons
          
          /* sfInput.addEventListener('input', this.updateQuantityNeeded.bind(this)); */
          sfInput.addEventListener('input', this.limitSquareFeetDecimals.bind(this));
          sfInput.addEventListener('input', this.updateSubtotalOverageTotalFields.bind(this));
          overageSelect.addEventListener('change', this.updateSubtotalOverageTotalFields.bind(this));

          sfInput.addEventListener('blur', function (event) {
            const input = event.target;
            const value = parseFloat(input.value);
          
            // Ensure the value is rounded to 2 decimal places on blur
            if (!isNaN(value)) {
              input.value = value.toFixed(0);
            }
          });

        // Update cartons when quantity changes
        const quantityInput = document.querySelector('.quantity__input');
        quantityInput.addEventListener('input', function() {
          const quantity = parseInt(this.value) || 0; // Get current quantity
          const sfPerCarton = parseFloat(document.getElementById('variantData').getAttribute('data-sf-per-carton'));
          const squareFeet = (quantity * sfPerCarton).toFixed(0);; // Calculate total square feet
          document.getElementById('sf_input').value = squareFeet; // Update the square feet input
          this.subtotalValue = document.querySelector('.subtotal-value'); // Reference to the subtotal value element
          this.overagePercentValue = document.querySelector('.overage-value'); // Reference to the overage value element
          const overageSelect = document.getElementById('overageSelect');
          const selectedValue = parseFloat(overageSelect.value); // Convert to a number
          const squarefootvalue = parseFloat(document.getElementById('sf_input').value); // Get the current value of square feet
          this.subtotalValue.textContent = `${(squarefootvalue * 1).toFixed(0)}`; // Update the subtotal value
          this.overagePercentValue.textContent = `${(squarefootvalue * selectedValue).toFixed(0)}`; // Update the subtotal value
        });
  
        
        // Handle square foot button clicks
        const squareFeetButtons = document.querySelectorAll(".quantity__button[name='plus-sq-ft'], .quantity__button[name='minus-sq-ft']");

        squareFeetButtons.forEach(button => {
          button.addEventListener("click", (event) => {
            const sfInput = document.getElementById('sf_input');
            const sfPerCarton = parseFloat(document.getElementById('variantData').getAttribute('data-sf-per-carton'));
            if (!sfInput) return;
        
            const isPlus = button.name === 'plus-sq-ft';
            const increment = isPlus ? sfPerCarton : -sfPerCarton;
        
            // Get current value and apply increment
            let currentValue = parseInt(sfInput.value) || 0;
            currentValue += increment;
        
            // Prevent going below 1 (or 0 if you prefer)
            if (currentValue < 1) currentValue = 1;
        
            sfInput.value = currentValue;
        
            this.updateSubtotalOverageTotalFields();
          });
        });
        

        /*squareFeetButtons.forEach(button => {
          button.addEventListener("click", (event) => { // Use an arrow function here
            const isPlus = button.name === 'plus-sq-ft';
            const quantityInput = document.querySelector('.quantity__input'); // Ensure this targets the correct input field
            const quantity = parseInt(quantityInput.value) || 0;
            const increment = isPlus ? 1 : -1;
            const newQuantity = Math.max(1, quantity + increment); // Ensure quantity doesn't go below 1
            quantityInput.value = newQuantity; // Update quantity input
            quantityInput.dispatchEvent(new Event('input')); // Trigger input event
            this.updateSubtotalOverageTotalFields();
          });
        });*/
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) => {
          html.querySelectorAll('.scroll-trigger').forEach((element) =>
            element.classList.add('scroll-trigger--cancel')
          );
        });

        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });

      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }
      
      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateCollapsibleContent(productUrl, variantId) {
        // Use AJAX to fetch the content related to the selected variant and update the collapsible section
        fetch(`${window.shopUrl}/${productUrl}/?variant=${variantId}`)

          .then(response => response.text())
          .then(html => {
            // Parse the new variant details from the returned HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
  
            // Get the new content from the fetched HTML
            const newPackaging = doc.querySelector('#variantData');
            const newProductDetails = doc.querySelector('#product-details-collapsible'); // Adjust selector based on your collapsible section class
            const newSquareFootageContent = doc.querySelector('#square-footage-fields');

            // Replace the current content with the new content
            const collapsibleContentSection = document.querySelector('#product-details-collapsible'); // Adjust selector based on your collapsible section class
            if (collapsibleContentSection && newProductDetails) {
              collapsibleContentSection.innerHTML = newProductDetails.innerHTML;
            }

            // Replace the current packaging content with the new content
            const packagingContentSection = document.querySelector('#variantData');
            if (packagingContentSection && newPackaging) {
              packagingContentSection.innerHTML = newPackaging.innerHTML;
            }

            // Replace the current square footage content with the new content
            const squarefootageContentSection = document.querySelector('#square-footage-fields');
            if (squarefootageContentSection && newSquareFootageContent) {
              squarefootageContentSection.innerHTML = newSquareFootageContent.innerHTML;
            }

            this.initializeVariantListeners();

          })
          .catch(error => {
            console.error('Error fetching variant content:', error);
          });
      }

      initializeVariantListeners() {    
       this.initSquareFootageButtons ();
      }      

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          if (!variant) {
            this.setUnavailable();
            return;
          }
      
          // Update collapsible content immediately
          this.updateCollapsibleContent(productUrl, variant?.id);
      
          const variantValues = variant.options
          const mediaGallery = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
          if (mediaGallery.hasAttribute("media-grouping-enabled")) {
            mediaGallery.querySelectorAll('[data-media-group]').forEach(el => el.classList.add('hide-media'))
            variantValues.forEach(value => { mediaGallery.querySelectorAll(`[data-media-group="${value}"]`).forEach(el => el.classList.remove('hide-media')) })
            mediaGallery.querySelectorAll('slider-component').forEach(slider => { slider.initPages() })
          }

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('product-form');
          updateSourceFromDestination('title');
          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          this.initSampleButton();
          
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      limitSquareFeetDecimals(event) {
        const input = event.target;
        let value = input.value;
    
        // Allow numbers with up to 2 decimal places
        if (!/^\d*\.?\d{0,2}$/.test(value)) {
            input.value = value.slice(0, -1); // Remove last invalid character
        }
    }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
    
  );

  document.addEventListener('DOMContentLoaded', () => {
    const infoIcon = document.querySelector('.info-icon');
    const closeBtn = document.querySelector('.close-tooltip');
    const tooltip = document.querySelector('.tooltip');
  
    if (infoIcon && tooltip) {
      infoIcon.addEventListener('click', (event) => {
        tooltip.classList.toggle('visible');
      });
    }
  
    if (closeBtn && tooltip) {
      closeBtn.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent the click from bubbling up
        tooltip.classList.remove('visible');
      });
    }
  
    if (tooltip && infoIcon) {
      document.addEventListener('click', (event) => {
        // If the click is outside both the tooltip and the icon, hide the tooltip
        if (!tooltip.contains(event.target) && !infoIcon.contains(event.target)) {
          tooltip.classList.remove('visible');
        }
      });
    }
  });
  

}